import {IParams as IAbstractParams, PermissionCellAbstract} from "./AbstractCell";
import {ErrorTracker} from "../../../../error.tracker";
import {global, lm} from "../../../../appContext";
import {ObjectTypeId} from "../../../../constants";
import {IObjectData, IRouteDefinition} from "../../../../index";
import {getRouteDefinition} from "../../../../constants/RouteDefinitions";
import managerofHtml from './managerof.html?raw';

export let template = managerofHtml;

interface IParams extends IAbstractParams {
    errorTracker: ErrorTracker
}

export class viewModel extends PermissionCellAbstract {

    private errorTracker: ErrorTracker;

    constructor(params: IParams) {
        super(params);
        this.errorTracker = params.errorTracker;
    }

    private onPickManagerOfClick() {
        const system = this.sp.system();
        if (!system) {
            return;
        }
        global.dialogManager.addComponent({
            title: lm.t('choose department') ?? '',
            fullWidth: false,
            content: {
                name: 'component/object/dialog/pick',
                params: {
                    objecttypeid: ObjectTypeId.Department,
                    selectedObject: (dep: IObjectData) => this.sp.managerOf(dep.id),
                    orgnr: system.companyid,
                }
            }
        });
    }

}
